import * as React from 'react';
import { IEmployeesFilterParams } from '../EmployeesComboboxMI';
import { RequestControl, IRelationRowTable, IEmployeeEntity } from '../Relations/RequestControl';
import { IUserAuthorizationData, IDictionary, IUserAuthorizationLoadingData } from './AuthUserAuthorizationsService';
import UserAuthorizationsWindow, { IUserAuthorizationsWindowConfig } from './UserAuthorizationsWindow';
import { IAuthorizationRelationRawData, IAuthorizationRelationData } from './AuthorizationDomainModel';
import lang from '../Relations/RelationsLang';
import { IIdNamePair } from '../../services/ResourceRelationsService';
import { AuthorizationLevelInputControl } from './AuthorizationLevelInputControl';
import { ILevelPermission } from './AuthorizationLevelControl';
import ResourcesAutocompleteMI, { OptionType } from '../ResourcesAutocompleteMI';
import { IConfig } from './Models';

import WarningEmployeeChange from '../Relations/WarningEmployeeChange';
import { createGridConfig, IGridResourcesConfig } from '../Relations/GridResourcesConfig';
import { RenderMultiEmployeesInput } from '../Relations/RenderMultiEmployeesInput';
import { ErrorMessageWithLabel } from '../Relations/Components';
import AddScopeButton from '../Relations/AddScopeButton';

const defaultDataSetGrid: IGridResourcesConfig = {
	title: lang.selectDataSet(),
	hidden: false,
	columns: [
		{ id: "name", label: lang.name(), minWidth: 210, searched: true, numeric: false },
		{ id: "type", label: lang.type(), searched: false, numeric: false },
		{ id: "status", label: lang.status(), searched: true, numeric: false },
		{ id: "city", label: lang.city(), searched: false, numeric: false },
		{ id: "company", label: lang.company(), searched: false, numeric: false },
		{ id: "department", label: lang.department(), searched: false, numeric: false }
	],
	filters: "",
	rowsPerPageOptions: null,
}

const defaultBusinessProcessGrid: IGridResourcesConfig = {
	title: lang.selectBusinessProcess(),
	hidden: false,
	columns: [
		{ id: "name", label: lang.name(), minWidth: 210, searched: true, numeric: false },
		{ id: "type", label: lang.type(), searched: false, numeric: false },
		{ id: "status", label: lang.status(), searched: true, numeric: false },
		{ id: "city", label: lang.city(), searched: false, numeric: false },
		{ id: "company", label: lang.company(), searched: false, numeric: false },
		{ id: "department", label: lang.department(), searched: false, numeric: false }
	],
	filters: "",
	rowsPerPageOptions: null,
}



interface IProps {
	blockInsert: boolean;

	selectedEmployees: OptionType[],
	onChangeSelectedEmployees: (v: OptionType[]) => void
	employeesFilters: IEmployeesFilterParams,

	selectedDataSets: OptionType[],
	onChangeSelectedDataSets: (v: OptionType[]) => void

	selectedBusinesProcesses: OptionType[],
	onChangeSelectedBussinesProcesses: (v: OptionType[]) => void

	table: RequestControl;

	checkAuthorizesInLog: (table: any[]) => void;
	rowsPerUsers: IDictionary<IUserAuthorizationData>,
	loading: IDictionary<IUserAuthorizationLoadingData>,

	allAuthorizationLevels: ILevelPermission[];

	blockChangeEmployees: boolean;

	hiddenCurrentAuthorizationsButton: boolean;

	currentAuthorizationsTable: IUserAuthorizationsWindowConfig,
	
	getLevelByName: (name: string) => IIdNamePair;

	config: IConfig,
}

interface IState {
	employeesError: string;
	resourcesError: string;

	warningEmployeeChange: OptionType;
	hasChanges: boolean;
}

export default class AuthorizationInsertForm extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			employeesError: "",
			resourcesError: "",
			warningEmployeeChange: null,
			hasChanges: false,
		}

		this.levelsInputs = new Map();
	}

	levelsInputs: Map<string, AuthorizationLevelInputControl>;

	public hasChanges(): boolean {

		if (this.props.selectedBusinesProcesses.length == 0 &&
			this.props.selectedDataSets.length == 0)
			return false;

		if (this.state.hasChanges)
			return true;

		return false;
	}

	handleAddClick() {
		let distinctOptions: IDictionary<OptionType> = {};
		for (var i = 0; i <= this.props.selectedEmployees.length; i++) {
			var emp = this.props.selectedEmployees[i];
			if (emp && !distinctOptions[emp.value]) {
				distinctOptions[emp.value] = emp;
			}
		}

		if (this.isValidAdd(distinctOptions)) {

			let itemsToPush: IAuthorizationRelationRawData[] = [];

			let uniqueEmployees = Object.values(distinctOptions) as OptionType[];

			if (uniqueEmployees.length == 0) {
				itemsToPush = this.createAuthorizationsByUser(null);
			}

			for (let i = 0; i < uniqueEmployees.length; i++) {
				let employeeEntity: IEmployeeEntity = null;
				employeeEntity = {
					id: parseInt(uniqueEmployees[i].value),
					name: uniqueEmployees[i].label,
					label: uniqueEmployees[i].label,
					kind: "Employee",
					type: null,
				};
				var newRows = this.createAuthorizationsByUser(employeeEntity);

				itemsToPush = itemsToPush.concat(newRows);
			}

			this.props.checkAuthorizesInLog(itemsToPush);
			this.props.table.push(itemsToPush);

			this.clear();
		}

		return false;
	}

	private createAuthorizationsByUser(employeeEntity: null | IEmployeeEntity): IAuthorizationRelationRawData[] {
		let itemsToPush: IAuthorizationRelationRawData[] = [];

		for (let j = 0; j < this.props.selectedDataSets.length; j++) {
			let resource = this.props.selectedDataSets[j];
			let addResource = this.pushResource(employeeEntity, resource);
			itemsToPush = itemsToPush.concat(addResource);
		}

		for (let j = 0; j < this.props.selectedBusinesProcesses.length; j++) {
			let resource = this.props.selectedBusinesProcesses[j];
			let addResource = this.pushResource(employeeEntity, resource);
			itemsToPush = itemsToPush.concat(addResource);
		}

		return itemsToPush;
	}

	pushResource(employee: null | IEmployeeEntity, resource: OptionType): IAuthorizationRelationRawData[]
	{
		let itemsToPush: IAuthorizationRelationRawData[] = [];

		let levelRefInput = this.levelsInputs.get(resource.value);
		if (!levelRefInput)
			return;

		let values = levelRefInput.getValues();

		if (values.levels.length == 0) {
			var exist = this._search(employee, resource)
			if (!exist) {
				itemsToPush.push({
					employee: employee,
					resource: {
						id: parseInt(resource.value),
						label: resource.label,
						kind: resource.kind,
					},
					level: null,
					from: values.from,
					to: values.to,
					errorMessages: [],
				});
			}
		}

		for (let k = 0; k < values.levels.length; k++) {
			let level = values.levels[k];

			var exist = this._search(employee, resource, level);
			if (!exist) {
				itemsToPush.push({
					employee: employee,
					resource: {
						id: parseInt(resource.value),
						label: resource.label,
						kind: resource.kind,
					},
					level: level,
					from: values.from,
					to: values.to,
					errorMessages: [],
				});
			}
		}

		return itemsToPush;
	}

	handleWarningAccept() {
		let rows = this.props.table.getRows();
		for (let i = 0; i < rows.length; i++) {
			let row = rows[i];
			row.deleted = true;
		}
		this.props.table.setRows(rows);
		this.setState({
			warningEmployeeChange: null
		});
	}

	handleWarningClose() {
		this.props.onChangeSelectedEmployees([null]);

		this.setState({
			warningEmployeeChange: null,
		});
	}

	renderUserAuthorizationsWindow(employee: OptionType) {
		if (this.props.hiddenCurrentAuthorizationsButton)
			return null;

		let rowsPerUser: IUserAuthorizationData = null;
		let loading: IUserAuthorizationLoadingData = {
			forBusinessProcess: false,
			forDataSet: false,
		};
		if (employee) {
			rowsPerUser = this.props.rowsPerUsers[employee.value];
			loading = this.props.loading[employee.value];
		}

		return <UserAuthorizationsWindow
			rowsPerUser={rowsPerUser}
			loading={loading}
			user={employee}
			canInsert={true}
			onInsert={(items) => {
				this.props.table.push(items);
			}}

			tableConfig={this.props.currentAuthorizationsTable}
			blockedRelationIds={() => this.props.table?.getRows().filter(x => !x.deleted && x.relationId).map(x => x.relationId) ?? []}
			getLevelByName={this.props.getLevelByName}

			config={this.props.config}
		/>
	}

	render() {

		let fields = this.props.config.fields;

		let anyResources = !fields.dataSet.hidden || !fields.businessProcess.hidden;
		
		return <>
			<RenderMultiEmployeesInput
				blockChangeEmployees={this.props.blockChangeEmployees}
				config={fields.employee}
				employeesError={this.state.employeesError}
				employeesFilters={this.props.employeesFilters}
				name="selectAuthorizationFor"
				label="authorizationFor"
				onChange={(v) => this.handleEmployeeChange(v)}
				getButtons={(e) => this.renderUserAuthorizationsWindow(e)}
				value={this.props.selectedEmployees}
			/>

			{!this.props.blockInsert && <>
				{this.renderResourcesInputs()}
				
				<div>
					{this.renderAuthorizationLevelsInput()}
				</div>
				{anyResources && <AddScopeButton
					onClick={this.handleAddClick.bind(this)}
				/>}
			</>}
			<WarningEmployeeChange
				warningEmployeeChange={this.state.warningEmployeeChange}
				onAccept={this.handleWarningAccept.bind(this)}
				onCancel={this.handleWarningClose.bind(this)}
			/>
		</>
	}

	renderResourcesInputs()
	{
		let fields = this.props.config.fields;
		let dataSetLabel = lang.getDefaultByPrefixOrFromStrings(fields.dataSet, "label", "dataSets");
		let businessProcessLabel = lang.getDefaultByPrefixOrFromStrings(fields.businessProcess, "label", "businessProcesses");

		const dataSetGrid = createGridConfig("selectDataSet", fields.dataSet.grid, defaultDataSetGrid);
		const businessProcessGrid = createGridConfig("selectBusinessProcess", fields.businessProcess.grid, defaultBusinessProcessGrid);

		return <>
			{!fields.dataSet.hidden && <div className="flex-form-field form-field-access-for">
				<div className="flex-field-label">
					<label>{dataSetLabel}:</label>
				</div>
				<div className="flex-field-input" style={{ marginRight: "7px" }}>
					<ErrorMessageWithLabel
						resourcesError={this.state.resourcesError}
						label={dataSetLabel}
					/>
					<ResourcesAutocompleteMI
						value={this.props.selectedDataSets}
						multiple={fields.dataSet.multiple}

						onSelect={this.handleDataSetsChange.bind(this)}
						kind="DataSet"
						filters={{
							maxRows: fields.dataSet.maxRows,
							filterId: fields.dataSet.filterId,
							loadOnFocus: fields.dataSet.loadOnFocus,
						}}
						placeholderText={lang.getDefaultByPrefix(fields.dataSet, "placeholder")}
						grid={dataSetGrid}
					/>
				</div>
			</div>}

			{!fields.businessProcess.hidden && <div className="flex-form-field form-field-access-for">
				<div className="flex-field-label">
					<label>{businessProcessLabel}:</label>
				</div>
				<div className="flex-field-input" style={{ marginRight: "7px" }}>
					<ErrorMessageWithLabel
						resourcesError={this.state.resourcesError}
						label={businessProcessLabel}
					/>
					<ResourcesAutocompleteMI
						value={this.props.selectedBusinesProcesses}
						multiple={fields.businessProcess.multiple}

						onSelect={this.handleBusinessProcessChange.bind(this)}
						kind="BusinessProcess"
						filters={{
							maxRows: fields.businessProcess.maxRows,
							filterId: fields.businessProcess.filterId,
							loadOnFocus: fields.businessProcess.loadOnFocus,
						}}
						placeholderText={lang.getDefaultByPrefix(fields.businessProcess, "placeholder")}
						grid={businessProcessGrid}
					/>
				</div>
			</div>}
		</>;
	}

	public handleEmployeeChange(items: OptionType[]) {
		this.props.onChangeSelectedEmployees(items);
		this.setState({
			hasChanges: true,
		});

		if (items.length == 0 || !items[0]) {
			// puste pole
			return;
		}

		if (this.props.config.fields.employee.multiple) {
			// pozwalamy na wielu pracownik�w
			return;
		}

		let item = items[0];

		let employeId = parseInt(item.value);

		let firstOrDefault = this.props.table?.searchSingle(x => x.employee?.id && x.employee.id != employeId);
		if (!firstOrDefault) {
			// we wniosku nie ma innych u�ytkonik�w
			return;
		}

		this.setState({
			warningEmployeeChange: item,
		})
	}

	private handleDataSetsChange(value: OptionType[]) {
		this.setState({ hasChanges: true });
		this.props.onChangeSelectedDataSets(value);
	}

	private handleBusinessProcessChange(value: OptionType[]) {
		this.setState({ hasChanges: true });
		this.props.onChangeSelectedBussinesProcesses(value);
	}

	renderAuthorizationLevelsInput() {

		return <div>
			{this.props.selectedBusinesProcesses?.map((res) => {
				return <AuthorizationLevelInputControl
					key={res.value}
					resourceName={res.label}
					ref={c => this.levelsInputs.set(res.value, c)}
					permissionLevels={this.props.allAuthorizationLevels}

					config={this.props.config}
					selectedEmployees={this.props.selectedEmployees}
				/>
			})}

			{this.props.selectedDataSets?.map((res) => {
				return <AuthorizationLevelInputControl
					key={res.value}
					resourceName={res.label}
					ref={c => this.levelsInputs.set(res.value, c)}
					permissionLevels={this.props.allAuthorizationLevels}

					config={this.props.config}
					selectedEmployees={this.props.selectedEmployees}
				/>
			})}
		</div>
	}

	private _search(employee, resource, levelId?: ILevelPermission): IRelationRowTable {
		var existRow = this.props.table.searchSingle((r) => {
			let row = r as IAuthorizationRelationData;
			let userAndResource = row.employee.id == employee.id
				&& row.resource.id == resource.id;

			let level;
			if (levelId)
				level = row.level && row.level.id == levelId.id;
			else
				level = !row.level;

			return userAndResource && level;
		});

		return existRow;
	}

	isValidAdd(employees: IDictionary<OptionType>) {
		let result = true;
		let state: any = {
			employeesError: "",
			resourcesError: "",
		};
		if (Object.keys(employees).length == 0 && !this.props.config.fields.employee.hidden) {
			state.employeesError = "control.relation.requireErrorMessage";
			result = false;
		}

		if (this.props.selectedDataSets.length == 0
			&& this.props.selectedBusinesProcesses.length == 0) {

			//let label = lang.get("authorizationTo");
			state.resourcesError ="control.relation.requireErrorMessage";
			result = false;
		}

		this.setState(state);

		this.levelsInputs.forEach((v) => {
			if (v)
				result = result && v.isValidAdd();
		});

		return result;
	}

	clear() {
		this.props.onChangeSelectedBussinesProcesses([]);
		this.props.onChangeSelectedDataSets([]);
		this.setState({
			hasChanges: false,
		})
	}
}

